module.exports = __webpack_public_path__ + "static/Xilloc-PEEK-Implant-99e738b78895c4c3523b85e10f20ab32.png";